// extracted by mini-css-extract-plugin
export default {"container":"Ml","overlay":"Nl","videoOverlay":"Ol","withHeader":"Pl","header":"Ql","close":"Rl","content":"Sl"};